import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

export const Container = styled.div`
  position: relative;

  border-radius: 12px;

  &::after {
    position: absolute;
    inset-block-start: -26px;
    inset-inline-start: 50%;
    content: "";
    z-index: 0;

    inline-size: 52px;
    block-size: 52px;

    border-radius: 50%;

    background: #ffca054d;

    transform: translateX(-50%);
  }
`;

export const Wrapper = styled.div<{ $isLoading: boolean }>`
  position: relative;
  z-index: 1;

  inline-size: 100%;
  max-inline-size: 480px;
  margin-inline: auto;
  padding-block: 20px 0;
  padding-inline: 20px;

  border-radius: 12px;

  background: #ffffff;

  box-shadow: 0 4px 4px 0 #0000001a;

  ${({ $isLoading }) => $isLoading && "min-block-size: 848px;"}

  &::before {
    position: absolute;
    inset: 0;
    content: "";

    border: 1px solid #00000026;
    border-radius: 12px;
  }

  &::after {
    position: absolute;
    inset-block-start: -10px;
    inset-inline-start: 50%;
    content: "";

    inline-size: 20px;
    block-size: 20px;

    border-radius: 50%;

    background: #ffca05;

    transform: translateX(-50%);
  }
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 704px;
    padding-block: 32px;
    padding-inline: 24px;

    box-shadow: none;

    ${({ $isLoading }) => $isLoading && "min-block-size: 802px;"}
  }
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 1024px;
    padding: 32px;

    ${({ $isLoading }) => $isLoading && "min-block-size: 774px;"}
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    ${({ $isLoading }) => $isLoading && "min-block-size: 741.27px;"}
  }
`;

export const TitleWrapper = styled.div`
  position: relative;
  z-index: 1;

  margin-block-end: 20px;

  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 32px;
  }
`;

export const Title = styled.div`
  margin-block-end: 8px;

  font-weight: 300;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 120%;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 4px;

    font-size: 32px;
  }
`;

export const Description = styled.div`
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 120%;
  ${theme.breakpoints.up("tablet")} {
    line-height: 19px;
  }
`;
